import React from 'react'

const SportCourt = ({ showHoveredTooltip = true, CourtGround, disableModal, currentCommentary, showZoneOnMobileScreen = false, isDeployTokenPage=false, courtOuterSvgId, previewGame, tokensToShowOnGround, hideZoneName = false, makeSelectable, selectZone, zonesToBeHighlighted, isLiveGame, purchasedTokens = [], hideHover = false, teamDetails=[], disableTokenHover, selectedZones=[] }) => {
  return (
    <CourtGround
      courtOuterSvgId={courtOuterSvgId}
      showHoveredTooltip={showHoveredTooltip}
      disableModal={disableModal}
      previewGame={previewGame}
      tokensToShowOnGround={tokensToShowOnGround}
      isDeployTokenPage={isDeployTokenPage}
      hideZoneName={hideZoneName}
      makeSelectable={makeSelectable}
      zonesToBeHighlighted={zonesToBeHighlighted}
      selectZone={selectZone}
      isLiveGame={isLiveGame}
      purchasedTokens={purchasedTokens}
      hideHover={hideHover}
      teamDetails={teamDetails}
      disableTokenHover={disableTokenHover}
      selectedZones={selectedZones}
      showZoneOnMobileScreen={showZoneOnMobileScreen}
      currentCommentary={currentCommentary}
    />
  )
}

export default React.memo(SportCourt);